<template>
    <v-card style="box-shadow: none" class="d-flex flex-column">
        <v-card-text stye="overflow-y: auto; height:75vh;">
            <v-row no-gutters>
                <v-col cols="12" class="d-flex mb-2">
                    <h2>Réglages de la période de votre prévisionnel</h2>
                </v-col>
                <!-- <v-col cols="6" class="d-flex mb-2">
                    Date de début du premier exercice
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <oss-date-picker-filled
                        v-model="date"
                        type="month"
                        format="MM-YYYY"

                        :text-field-readonly="false"
                        hide-details="auto"
                        @change-date="onDateChanged"
                        >
                    </oss-date-picker-filled>
                </v-col> -->
                <v-col cols="6" class="d-flex mb-2"> Nombre d'exercices du prévisionnel </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <v-select-filled
                        v-model="parameters.periodsNumber"
                        :items="selectPeriodsNumber"
                        item-value="id"
                        single-line
                        required
                        label="Nombre d'exercices"
                        hide-details="auto"
                        density="compact"
                        :item-title="(item) => item.name"
                    />
                </v-col>
                <!-- <v-col cols="6" class="d-flex mb-2">
                    Durée du prévisionnel étendu
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <v-select

                        v-model="parameters.extendedPrevisionalDuration"
                        :items="selectExtendedPrevisionalPeriod"
                        item-text="name"
                        item-value="id"
                        single-line
                        dense
                        required
                        class="oss-"
                        label="Durée du prévisionnel étendu"
                        hide-details="auto"
                    ></v-select>
                </v-col> -->
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" class="d-flex mb-2">
                    <h2>Délais de règlement</h2>
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <h4>Clients</h4>
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <v-select-filled
                        v-model="parameters.paymentDelayClient"
                        :items="paymentDelays"
                        item-value="id"
                        single-line
                        required
                        label="Temps que met le client à vous payer"
                        hide-details="auto"
                        density="compact"
                        :item-title="(item) => item.name"
                    />
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <h4>Fournisseur sur charge fixe</h4>
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <v-select-filled
                        v-model="parameters.paymentDelaySupplierPurchase"
                        :items="paymentDelays"
                        item-value="id"
                        single-line
                        required
                        label="Temps que vous mettez à payer un fournisseur"
                        hide-details="auto"
                        density="compact"
                        :item-title="(item) => item.name"
                    />
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <h4>Fournisseur sur charge variable</h4>
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <v-select-filled
                        v-model="parameters.paymentDelaySupplierCosts"
                        :items="paymentDelays"
                        item-value="id"
                        single-line
                        required
                        label="Temps que vous mettez à payer un fournisseur"
                        hide-details="auto"
                        density="compact"
                        :item-title="(item) => item.name"
                    />
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" class="d-flex mb-2">
                    <h2>Valeurs moyennes de TVA</h2>
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <h4>TVA sur activité</h4>
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <oss-text-field-filled
                        label="%"
                        single-line
                        hide-details="auto"
                        v-model="parameters.vatSell"
                    />
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <h4>TVA sur charges fixes</h4>
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <oss-text-field-filled
                        label="%"
                        single-line
                        hide-details="auto"
                        v-model="parameters.vatPurchase"
                    />
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <h4>TVA sur charges variables</h4>
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <oss-text-field-filled
                        label="%"
                        single-line
                        hide-details="auto"
                        v-model="parameters.vatCost"
                    />
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <h4>TVA sur immobilisations</h4>
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <oss-text-field-filled
                        label="%"
                        single-line
                        hide-details="auto"
                        v-model="parameters.vatImmo"
                    />
                </v-col>
                <!-- <v-col cols="6" class="d-flex mb-2">
                    <h4>Autres TVA</h4>
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <oss-text-field-filled
                        class="oss-"
                        v-model.number="parameters.vatOther"
                        type="number"
                        label="%"

                        single-line
                        hide-details="auto"
                    ></oss-text-field>
                </v-col> -->
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" class="d-flex mb-2">
                    <h2>Charges salariales pour un employé</h2>
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <h4>Taux de charges salariales (employé)</h4>
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <oss-text-field-filled
                        label="%"
                        single-line
                        hide-details="auto"
                        v-model="parameters.wagesTax"
                    />
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <h4>Taux de charges patronales (employé)</h4>
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <oss-text-field-filled
                        label="%"
                        single-line
                        hide-details="auto"
                        v-model="parameters.employerTax"
                    />
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <h4>Taux de charges globales (dirigeant)</h4>
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <oss-text-field-filled
                        label="%"
                        single-line
                        hide-details="auto"
                        v-model="parameters.globalTax"
                    />
                </v-col>
                <!-- <v-col cols="6" class="d-flex mb-2">
                    <h4>Paiement des salaires</h4>
                </v-col> -->
                <!-- <v-col cols="6" class="d-flex mb-2">
                    <v-select
                        v-model="parameters.monthOfWagesPayment"
                        :items="monthsOfWagesPayment"

                        single-line
                        dense
                        required
                        class="oss-"
                        label="Mois du paiement des salaires"
                        hide-details="auto"
                    ></v-select>
                </v-col> -->
                <!-- <v-col cols="6" class="d-flex mb-2">
                    <h4>Paiement au trimestre civil</h4>
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <oss-text-field-filled
                        class="oss-"
                        v-model.number="parameters.percentageOfCalendarQuarterPayment"
                        type="number"
                        label="%"

                        single-line
                        hide-details="auto"
                    ></oss-text-field>
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <h4>Paiement mensuel</h4>
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <oss-text-field-filled
                        class="oss-"
                        v-model.number="parameters.percentageOfMonthlyPayment"
                        type="number"
                        label="%"

                        single-line
                        hide-details="auto"
                    ></oss-text-field>
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <h4>Caisse de congés payés (bâtiment)</h4>
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <oss-text-field-filled
                        class="oss-"
                        v-model.number="parameters.paidHolidayFund.holidaysSaisonnality"
                        type="number"
                        label="%"

                        single-line
                        hide-details="auto"
                    ></oss-text-field>
                </v-col> -->
            </v-row>
            <v-row no-gutters>
                <v-col cols="12" class="d-flex mb-2">
                    <h2>Financement</h2>
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <h4>Mode d'assurance emprunteur</h4>
                </v-col>
                <v-col cols="6" class="d-flex mb-2">
                    <v-select-filled
                        v-model="parameters.loanInsuranceMode"
                        :items="loanInsuranceModes"
                        item-value="id"
                        single-line
                        required
                        label="Mode d'assurance emprunteur"
                        hide-details="auto"
                        density="compact"
                        :item-title="(item) => item.name"
                    />
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script lang="ts">
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component
export class BudgetParameters extends Vue {
    @Prop({ default: null }) parameters: any;

    selectPeriodsNumber = [
        { id: 1, name: "1 exercice" },
        { id: 2, name: "2 exercices" },
        { id: 3, name: "3 exercices" },
        { id: 4, name: "4 exercices" },
        { id: 5, name: "5 exercices" },
    ];

    selectExtendedPrevisionalPeriod = [
        { id: 1, name: "1 exercice" },
        { id: 2, name: "2 exercices" },
        { id: 3, name: "3 exercices" },
        { id: 4, name: "4 exercices" },
        { id: 5, name: "5 exercices" },
        { id: 6, name: "6 exercices" },
        { id: 7, name: "7 exercices" },
        { id: 8, name: "8 exercices" },
        { id: 9, name: "9 exercices" },
        { id: 10, name: "10 exercices" },
    ];

    paymentDelays = [
        { id: 0, name: "0 jours" },
        { id: 1, name: "30 jours" },
        { id: 2, name: "60 jours" },
        { id: 3, name: "90 jours" },
        { id: 4, name: "120 jours" },
        { id: 5, name: "150 jours" },
        { id: 6, name: "180 jours" },
    ];

    loanInsuranceModes = [
        { id: "CE", name: "sur capital emprunté" },
        { id: "CRD", name: "sur capital restant dû" },
    ];
}

export default toNative(BudgetParameters);
</script>

<style></style>
